import { render } from "./ApartmentBlock.vue?vue&type=template&id=430bedb7&scoped=true"
import script from "./ApartmentBlock.vue?vue&type=script&lang=js"
export * from "./ApartmentBlock.vue?vue&type=script&lang=js"

import "./ApartmentBlock.vue?vue&type=style&index=0&id=430bedb7&scoped=true&lang=scss"

import exportComponent from "/home/forge/mooz360.co.il/app-src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-430bedb7"]])

export default __exports__